import { format, parse, isValid } from 'date-fns';

export const MOMENT_FORMATS = [
  "DD.MM.YYYY",
  "DD-MM-YYYY",
  "DD/MM/YYYY",
  "MM-DD-YYYY",
  "MM.DD.YYYY",
  "MM/DD/YYYY",
  "YYYY-MM-DD",
  "YYYY.MM.DD",
  "YYYY/MM/DD"
];

export const DATE_FORMAT_OPTIONS = [
  "DD.MM.YYYY",
  "MM.DD.YYYY",
  "YYYY.MM.DD",
  "DD-MM-YYYY",
  "MM-DD-YYYY",
  "YYYY-MM-DD",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "YYYY/MM/DD",
];

/** Converts a moment format string to a date-fns format string */
export const toDateFnsFormat = (momentFormat) => {
  if (!momentFormat) return 'dd/MM/yyyy';
  return momentFormat
    .replace(/YYYY/g, 'yyyy')
    .replace(/DD/g, 'dd')
    .replace(/Do/g, 'do');
};

/** Parses a date string using the given moment-style format, returns a Date or null */
export const parseDate = (dateString, formatStr) => {
  if (!dateString) return null;
  const dateFnsFormat = toDateFnsFormat(formatStr);
  const parsed = parse(dateString, dateFnsFormat, new Date());
  return isValid(parsed) ? parsed : null;
};

/**
 * Detects which of the MOMENT_FORMATS matches the dateString,
 * parses it, and returns it formatted as "DD-MM-YYYY" (date-fns: "dd-MM-yyyy").
 */
export const reformatDate2 = (date, dateFormat) => {
  // Legacy signature: if dateFormat is provided, treat as moment-style format
  if (dateFormat) {
    const parsed = parseDate(date, dateFormat);
    return parsed ? format(parsed, 'dd-MM-yyyy') : null;
  }

  // Multi-format auto-detection
  if (!date) return null;
  for (const fmt of MOMENT_FORMATS) {
    const parsed = parseDate(date, fmt);
    if (parsed) {
      return format(parsed, 'dd-MM-yyyy');
    }
  }
  return null;
};

/** Reformats a date to ISO date string (YYYY-MM-DD), returns null if invalid */
export const reformatDate = (date) => {
  if (!date) return null;
  const dateValue = new Date(date);
  if (!isValid(dateValue)) return null;
  return format(dateValue, 'yyyy-MM-dd');
};